/**
 * @author Codex
 * @date 2026.03.11
 * @description 가맹점 부가 정보 관련 유틸리티
 */
export interface IFranchiseMailOrderSource {
  mailOrderNumber?: string | null;
  communicationSalesNumber?: string | null;
  onlineSalesNumber?: string | null;
  commerceNumber?: string | null;
}

export const getFranchiseMailOrderNumber = (
  franchise?: IFranchiseMailOrderSource | null
) => {
  if (!franchise) {
    return '';
  }

  return (
    franchise.mailOrderNumber?.trim() ||
    franchise.communicationSalesNumber?.trim() ||
    franchise.onlineSalesNumber?.trim() ||
    franchise.commerceNumber?.trim() ||
    ''
  );
};
